export default "__VITE_ASSET__CEEv4IS8__"